// src/components/Header.tsx
import React from 'react';
import { User, LogOut } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import { NavLink, useNavigate } from 'react-router-dom';

const Header: React.FC = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const navLinkStyle = ({ isActive }: { isActive: boolean }) => ({
    background: 'none',
    border: 'none',
    color: '#ffffff',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: isActive ? 'bold' : 'normal',
    padding: '0.5rem 0',
    borderBottom: isActive ? '2px solid #51eefc' : 'none',
    textDecoration: 'none'
  });

  return (
    <header style={{ 
      backgroundColor: '#1269cc', 
      color: '#ffffff', 
      padding: '1rem 2rem',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      position: 'sticky',
      top: 0,
      zIndex: 100
    }}>
      <div style={{ 
        margin: '0 auto', 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '1rem'
      }}>
        <NavLink 
          to="/" 
          style={{ 
            margin: 0, 
            fontSize: '1.75rem', 
            cursor: 'pointer',
            fontWeight: 'bold',
            color: '#ffffff',
            textDecoration: 'none'
          }}
        >
          LetShop
        </NavLink>
        <nav style={{ display: 'flex', gap: '2rem', alignItems: 'center', flexWrap: 'wrap' }}>
          <NavLink 
            to="/" 
            style={navLinkStyle}
            end
          >
            Home
          </NavLink>
          <NavLink 
            to="/products" 
            style={navLinkStyle}
          >
            Products
          </NavLink>
          
          {isAuthenticated ? (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <User size={20} />
                <span style={{ fontSize: '0.9rem' }}>{user?.name}</span>
              </div>
              <button
                onClick={handleLogout}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#ffffff',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  fontSize: '0.9rem',
                  padding: '0.5rem'
                }}
                title="Logout"
              >
                <LogOut size={18} />
              </button>
            </>
          ) : (
            <NavLink 
              to="/login" 
              style={navLinkStyle}
            >
              Login
            </NavLink>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;